<template>
  <div id='write' class=''>
    <h1><a name="图片授权范围" class="md-header-anchor"></a><span>图片授权范围</span></h1>
    <p><span>本授权为单一授权许可，仅授权一位自然人或者企业主体使用，您购买获得图片的授权后，该图片将保存到“企业素材”中，在授权限制范围内，您可以无限次使用。</span></p>
    <h3><a name="一授权范围" class="md-header-anchor"></a><span>一、授权范围</span></h3>
    <p><span>您可以如何使用授权内容的范例包括：</span></p>
    <figure>
      <table>
        <thead>
          <tr>
            <th style='text-align:center;'><span>用途范围</span></th>
            <th style='text-align:left;'><span>细项</span></th>
            <th style='text-align:center;'><span>标准授权</span></th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td style='text-align:center;'><strong><span>线上宣传</span></strong></td>
            <td style='text-align:left;'><span>线上广告</span></td>
            <td style='text-align:center;'><span>✅ </span></td>
          </tr>
          <tr>
            <td style='text-align:center;'>&nbsp;</td>
            <td style='text-align:left;'><span>电子出版物</span></td>
            <td style='text-align:center;'><span>✅</span></td>
          </tr>
          <tr>
            <td style='text-align:center;'><strong><span>数字用途</span></strong></td>
            <td style='text-align:left;'><span>网页文章配图</span></td>
            <td style='text-align:center;'><span>✅</span></td>
          </tr>
          <tr>
            <td style='text-align:center;'>&nbsp;</td>
            <td style='text-align:left;'><span>微信、微博配图</span></td>
            <td style='text-align:center;'><span>✅</span></td>
          </tr>
          <tr>
            <td style='text-align:center;'>&nbsp;</td>
            <td style='text-align:left;'><span>头条号等新媒体平台配图 </span></td>
            <td style='text-align:center;'><span>✅</span></td>
          </tr>
          <tr>
            <td style='text-align:center;'><strong><span>电商海报</span></strong></td>
            <td style='text-align:left;'><span>网店的海报、主体</span></td>
            <td style='text-align:center;'><span>✅</span></td>
          </tr>
          <tr>
            <td style='text-align:center;'>&nbsp;</td>
            <td style='text-align:left;'><span>商品详情页等</span></td>
            <td style='text-align:center;'><span>✅</span></td>
          </tr>
          <tr>
            <td style='text-align:center;'><strong><span>线下印刷</span></strong></td>
            <td style='text-align:left;'><span>宣传页、折页、广告海报</span></td>
            <td style='text-align:center;'><span>✅</span></td>
          </tr>
          <tr>
            <td style='text-align:center;'><span>（50万份以内）</span></td>
            <td style='text-align:left;'><span>门店陈设、易拉宝</span></td>
            <td style='text-align:center;'><span>✅</span></td>
          </tr>
          <tr>
            <td style='text-align:center;'>&nbsp;</td>
            <td style='text-align:left;'><span>书籍、杂志</span></td>
            <td style='text-align:center;'><span>✅</span></td>
          </tr>
          <tr>
            <td style='text-align:center;'><strong><span>媒体应用</span></strong></td>
            <td style='text-align:left;'><span>电视、电影</span></td>
            <td style='text-align:center;'><span>✅</span></td>
          </tr>
          <tr>
            <td style='text-align:center;'><span>（制作预算¥10万内）</span></td>
            <td style='text-align:left;'><span>网络视频</span></td>
            <td style='text-align:center;'><span>✅</span></td>
          </tr>
          <tr>
            <td style='text-align:center;'>&nbsp;</td>
            <td style='text-align:left;'>&nbsp;</td>
            <td style='text-align:center;'>&nbsp;</td>
          </tr>
        </tbody>
      </table>
    </figure>
    <h3><a name="二授权限制" class="md-header-anchor"></a><span>二、授权限制</span></h3>
    <p><span>被授权人用户不得将内容用于以下范围，具体包括：</span></p>
    <ol start=''>
      <li><span>任何以展示素材为主要目的的产品对外销售、发布，如台历、日历、明信片、装饰画、贺卡等用途；</span></li>
      <li><span>任何以销售为主要目的的产品，如杯子、鼠标垫、T恤、衣服、游戏、玩具、手机壳等产品或装潢艺术品等；</span></li>
      <li><span>烟草、酒精、药物、整容、医疗保健产品的广告或推广项目；</span></li>
      <li><span>以任何允许其他人以独立文件的形式下载、提取、转发、接触或再分销内容的方式使用内容（即仅使用内容文件本身，与项目或最终用途相分离）；</span></li>
      <li><span>将内容用作任何商标、设计标志、商号、商业名称、服务标识或标示的一部分；</span></li>
      <li><span>以诽谤、诋毁性或其他违反任何使用法律法规或行业规范的形式使用内容。</span></li>
    </ol><br>
    <h3><a name="三知识产权" class="md-header-anchor"></a><span>三、知识产权</span></h3>
    <p><span>除网站另有特别提示的以外，所有授权内容皆归属授权方及其合作伙伴或供图作者所有，本协议中没有明文授予的所有权利皆由授权方及其合作伙伴或供图作者保留。</span><br><br></p>
  </div>
</template>
<script>
export default {
  name: "Authorization"
};
</script>
<style scoped>
html {
  overflow-x: initial !important
}

:root {
  --bg-color: #fff;
  --text-color: #333;
  --select-text-bg-color: #b5d6fc;
  --select-text-font-color: auto;
  --monospace: "Lucida Console", Consolas, "Courier", monospace;
  --title-bar-height: 20px
}

.mac-os-11 {
  --title-bar-height: 28px
}

html {
  font-size: 14px;
  background-color: var(--bg-color);
  color: var(--text-color);
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased
}

body {
  margin: 0;
  padding: 0;
  height: auto;
  bottom: 0;
  top: 0;
  left: 0;
  right: 0;
  font-size: 1rem;
  line-height: 1.42857143;
  overflow-x: hidden;
  background-image: inherit;
  background-size: inherit;
  background-attachment: inherit;
  background-origin: inherit;
  background-clip: inherit;
  background-color: inherit;
  tab-size: 4;
  background-position: inherit inherit;
  background-repeat: inherit inherit
}

iframe {
  margin: auto
}

::marker {
  color: #7966f6
}

a.url {
  word-break: break-all
}

a:active,
a:hover {
  outline: 0
}

.in-text-selection,
::selection {
  text-shadow: none;
  background: var(--select-text-bg-color);
  color: var(--select-text-font-color)
}

#write {
  margin: 0 auto;
  height: auto;
  width: inherit;
  word-break: normal;
  word-wrap: break-word;
  position: relative;
  white-space: normal;
  overflow-x: visible;
  margin-left: auto !important;;
}

#write.first-line-indent p {
  text-indent: 2em
}

#write.first-line-indent li p,
#write.first-line-indent p * {
  text-indent: 0
}

#write.first-line-indent li {
  margin-left: 2em
}

.for-image #write {
  padding-left: 8px;
  padding-right: 8px
}

body.typora-export {
  padding-left: 30px;
  padding-right: 30px
}

.typora-export .footnote-line,
.typora-export li,
.typora-export p {
  white-space: pre-wrap
}

.typora-export .task-list-item input {
  pointer-events: none
}

@media screen and (max-width:500px) {
  body.typora-export {
    padding-left: 0;
    padding-right: 0
  }

  #write {
    padding-left: 20px;
    padding-right: 20px
  }

  .CodeMirror-sizer {
    margin-left: 0 !important
  }

  .CodeMirror-gutters {
    display: none !important
  }
}

#write li>figure:last-child {
  margin-bottom: .5rem
}

#write ol,
#write ul {
  position: relative
}

img {
  max-width: 100%;
  vertical-align: middle;
  image-orientation: from-image
}

button,
input,
select,
textarea {
  color: inherit;
  font-family: inherit;
  font-size: inherit;
  font-style: inherit;
  font-variant-caps: inherit;
  font-weight: inherit;
  font-stretch: inherit;
  line-height: inherit
}

input[type="checkbox"],
input[type="radio"] {
  line-height: normal;
  padding: 0
}

*,
::after,
::before {
  box-sizing: border-box
}

#write h1,
#write h2,
#write h3,
#write h4,
#write h5,
#write h6,
#write p,
#write pre {
  width: inherit
}

#write h1,
#write h2,
#write h3,
#write h4,
#write h5,
#write h6,
#write p {
  position: relative
}

p {
  line-height: inherit
}

h1,
h2,
h3,
h4,
h5,
h6 {
  break-after: avoid-page;
  break-inside: avoid;
  orphans: 4
}

p {
  orphans: 4
}

h1 {
  font-size: 2rem
}

h2 {
  font-size: 1.8rem
}

h3 {
  font-size: 1.6rem
}

h4 {
  font-size: 1.4rem
}

h5 {
  font-size: 1.2rem
}

h6 {
  font-size: 1rem
}

.md-math-block,
.md-rawblock,
h1,
h2,
h3,
h4,
h5,
h6,
p {
  margin-top: 1rem;
  margin-bottom: 1rem
}

.hidden {
  display: none
}

.md-blockmeta {
  color: #ccc;
  font-weight: 700;
  font-style: italic
}

a {
  cursor: pointer
}

sup.md-footnote {
  padding: 2px 4px;
  background-color: rgba(238, 238, 238, 0.7);
  color: #555;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
  border-bottom-left-radius: 4px;
  cursor: pointer
}

sup.md-footnote a,
sup.md-footnote a:hover {
  color: inherit;
  text-transform: inherit;
  text-decoration: inherit
}

#write input[type="checkbox"] {
  cursor: pointer;
  width: inherit;
  height: inherit
}

figure {
  overflow-x: auto;
  margin: 1.2em 0;
  max-width: calc(100%+16px);
  padding: 0
}

figure>table {
  margin: 0
}

tr {
  break-inside: avoid;
  break-after: auto
}

thead {
  display: table-header-group
}

table {
  border-collapse: collapse;
  border-spacing: 0;
  width: 100%;
  overflow: auto;
  break-inside: auto;
  text-align: left
}

table.md-table td {
  min-width: 32px
}

.CodeMirror-gutters {
  border-right-width: 0;
  background-color: inherit
}

.CodeMirror {
  text-align: left
}

.CodeMirror-placeholder {
  opacity: .3
}

.CodeMirror pre {
  padding: 0 4px
}

.CodeMirror-lines {
  padding: 0
}

div.hr:focus {
  cursor: none
}

#write pre {
  white-space: pre-wrap
}

#write.fences-no-line-wrapping pre {
  white-space: pre
}

#write pre.ty-contain-cm {
  white-space: normal
}

.CodeMirror-gutters {
  margin-right: 4px
}

.md-fences {
  font-size: .9rem;
  display: block;
  break-inside: avoid;
  text-align: left;
  overflow: visible;
  white-space: pre;
  background-image: inherit;
  background-size: inherit;
  background-attachment: inherit;
  background-origin: inherit;
  background-clip: inherit;
  background-color: inherit;
  position: relative !important;
  background-position: inherit inherit;
  background-repeat: inherit inherit
}

.md-diagram-panel {
  width: 100%;
  margin-top: 10px;
  text-align: center;
  padding-top: 0;
  padding-bottom: 8px;
  overflow-x: auto
}

#write .md-fences.mock-cm {
  white-space: pre-wrap
}

.md-fences.md-fences-with-lineno {
  padding-left: 0
}

#write.fences-no-line-wrapping .md-fences.mock-cm {
  white-space: pre;
  overflow-x: auto
}

.md-fences.mock-cm.md-fences-with-lineno {
  padding-left: 8px
}

.CodeMirror-line,
twitterwidget {
  break-inside: avoid
}

.footnotes {
  opacity: .8;
  font-size: .9rem;
  margin-top: 1em;
  margin-bottom: 1em
}

.footnotes+.footnotes {
  margin-top: 0
}

.md-reset {
  margin: 0;
  padding: 0;
  border: 0;
  outline: 0;
  vertical-align: top;
  text-decoration: none;
  text-shadow: none;
  float: none;
  position: static;
  width: auto;
  height: auto;
  white-space: nowrap;
  cursor: inherit;
  line-height: normal;
  font-weight: 400;
  text-align: left;
  box-sizing: content-box;
  direction: ltr;
  background-position: 0 0;
  background-repeat: initial initial
}

li div {
  padding-top: 0
}

blockquote {
  margin: 1rem 0
}

li .mathjax-block,
li p {
  margin: .5rem 0
}

li blockquote {
  margin: 1rem 0
}

li {
  margin: 0;
  position: relative
}

blockquote>:last-child {
  margin-bottom: 0
}

blockquote>:first-child,
li>:first-child {
  margin-top: 0
}

.footnotes-area {
  color: #888;
  margin-top: .714rem;
  padding-bottom: .143rem;
  white-space: normal
}

#write .footnote-line {
  white-space: pre-wrap
}

@media print {

  body,
  html {
    border: 1px solid transparent;
    height: 99%;
    break-after: avoid;
    break-before: avoid;
    font-variant-ligatures: no-common-ligatures
  }

  #write {
    margin-top: 0;
    padding-top: 0;
    border-color: transparent !important
  }

  .typora-export * {
    -webkit-print-color-adjust: exact
  }

  .typora-export #write {
    break-after: avoid
  }

  .typora-export #write::after {
    height: 0
  }

  .is-mac table {
    break-inside: avoid
  }
}

.footnote-line {
  margin-top: .714em;
  font-size: .7em
}

a img,
img a {
  cursor: pointer
}

pre.md-meta-block {
  font-size: .8rem;
  min-height: .8rem;
  white-space: pre-wrap;
  background-color: #ccc;
  display: block;
  overflow-x: hidden;
  background-position: initial initial;
  background-repeat: initial initial
}

p>.md-image:only-child:not(.md-img-error) img,
p>img:only-child {
  display: block;
  margin: auto
}

#write.first-line-indent p>.md-image:only-child:not(.md-img-error) img {
  left: -2em;
  position: relative
}

p>.md-image:only-child {
  display: inline-block;
  width: 100%
}

#write .MathJax_Display {
  margin: .8em 0 0
}

.md-math-block {
  width: 100%
}

.md-math-block:not(:empty)::after {
  display: none
}

.MathJax_ref {
  fill: currentcolor
}

[contenteditable="true"]:active,
[contenteditable="true"]:focus,
[contenteditable="false"]:active,
[contenteditable="false"]:focus {
  outline: 0;
  box-shadow: none
}

.md-task-list-item {
  position: relative;
  list-style-type: none
}

.task-list-item.md-task-list-item {
  padding-left: 0
}

.md-task-list-item>input {
  position: absolute;
  top: 0;
  left: 0;
  margin-left: -1.2em;
  margin-top: calc(1em - 10px);
  border: 0
}

.math {
  font-size: 1rem
}

.md-toc {
  min-height: 3.58rem;
  position: relative;
  font-size: .9rem;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  border-bottom-right-radius: 10px;
  border-bottom-left-radius: 10px
}

.md-toc-content {
  position: relative;
  margin-left: 0
}

.md-toc-content::after,
.md-toc::after {
  display: none
}

.md-toc-item {
  display: block;
  color: #4183c4
}

.md-toc-item a {
  text-decoration: none
}

.md-toc-inner:hover {
  text-decoration: underline
}

.md-toc-inner {
  display: inline-block;
  cursor: pointer
}

.md-toc-h1 .md-toc-inner {
  margin-left: 0;
  font-weight: 700
}

.md-toc-h2 .md-toc-inner {
  margin-left: 2em
}

.md-toc-h3 .md-toc-inner {
  margin-left: 4em
}

.md-toc-h4 .md-toc-inner {
  margin-left: 6em
}

.md-toc-h5 .md-toc-inner {
  margin-left: 8em
}

.md-toc-h6 .md-toc-inner {
  margin-left: 10em
}

@media screen and (max-width:48em) {
  .md-toc-h3 .md-toc-inner {
    margin-left: 3.5em
  }

  .md-toc-h4 .md-toc-inner {
    margin-left: 5em
  }

  .md-toc-h5 .md-toc-inner {
    margin-left: 6.5em
  }

  .md-toc-h6 .md-toc-inner {
    margin-left: 8em
  }
}

a.md-toc-inner {
  font-size: inherit;
  font-style: inherit;
  font-weight: inherit;
  line-height: inherit
}

.footnote-line a:not(.reversefootnote) {
  color: inherit
}

.md-attr {
  display: none
}

.md-fn-count::after {
  content: "."
}

code,
pre,
samp,
tt {
  font-family: var(--monospace)
}

kbd {
  margin: 0 .1em;
  padding: .1em .6em;
  font-size: .8em;
  color: #242729;
  background-color: #fff;
  border: 1px solid #adb3b9;
  border-top-left-radius: 3px;
  border-top-right-radius: 3px;
  border-bottom-right-radius: 3px;
  border-bottom-left-radius: 3px;
  box-shadow: rgba(12, 13, 14, 0.2) 0 1px 0, #fff 0 0 0 2px inset;
  white-space: nowrap;
  vertical-align: middle;
  background-position: initial initial;
  background-repeat: initial initial
}

.md-comment {
  color: #a27f03;
  opacity: .8;
  font-family: var(--monospace)
}

code {
  text-align: left
}

a.md-print-anchor {
  white-space: pre !important;
  border: none !important;
  display: inline-block !important;
  position: absolute !important;
  width: 1px !important;
  right: 0 !important;
  outline: 0 !important;
  text-shadow: initial !important;
  background-position: 0 0 !important;
  background-repeat: initial initial !important
}

.md-inline-math .MathJax_SVG .noError {
  display: none !important
}

.html-for-mac .inline-math-svg .MathJax_SVG {
  vertical-align: .2px
}

.md-math-block .MathJax_SVG_Display {
  text-align: center;
  margin: 0;
  position: relative;
  text-indent: 0;
  max-width: none;
  max-height: none;
  min-height: 0;
  min-width: 100%;
  width: auto;
  overflow-y: hidden;
  display: block !important
}

.MathJax_SVG_Display,
.md-inline-math .MathJax_SVG_Display {
  width: auto;
  margin: inherit;
  display: inline-block !important
}

.MathJax_SVG .MJX-monospace {
  font-family: var(--monospace)
}

.MathJax_SVG .MJX-sans-serif {
  font-family: sans-serif
}

.MathJax_SVG {
  display: inline;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  zoom: 90%;
  text-indent: 0;
  text-align: left;
  text-transform: none;
  letter-spacing: normal;
  word-spacing: normal;
  word-wrap: normal;
  white-space: nowrap;
  float: none;
  direction: ltr;
  max-width: none;
  max-height: none;
  min-width: 0;
  min-height: 0;
  border: 0;
  padding: 0;
  margin: 0
}

.MathJax_SVG * {
  transition: none
}

.MathJax_SVG_Display svg {
  vertical-align: middle !important;
  margin-bottom: 0 !important;
  margin-top: 0 !important
}

.os-windows.monocolor-emoji .md-emoji {
  font-family: "Segoe UI Symbol", sans-serif
}

.md-diagram-panel>svg {
  max-width: 100%
}

[lang="flow"] svg,
[lang="mermaid"] svg {
  max-width: 100%;
  height: auto
}

[lang="mermaid"] .node text {
  font-size: 1rem
}

table tr th {
  border-bottom-width: 0
}

video {
  max-width: 100%;
  display: block;
  margin: 0 auto
}

iframe {
  max-width: 100%;
  width: 100%;
  border: 0
}

.highlight td,
.highlight tr {
  border: 0
}

mark {
  background-color: #ff0;
  color: #000;
  background-position: initial initial;
  background-repeat: initial initial
}

.md-html-inline .md-plain,
.md-html-inline strong,
mark .md-inline-math,
mark strong {
  color: inherit
}

mark .md-meta {
  color: #000;
  opacity: .3 !important
}

@media print {

  .typora-export h1,
  .typora-export h2,
  .typora-export h3,
  .typora-export h4,
  .typora-export h5,
  .typora-export h6 {
    break-inside: avoid
  }
}

.md-diagram-panel .messageText {
  stroke: none !important
}

.md-diagram-panel .start-state {
  fill: var(--node-fill)
}

.md-diagram-panel .edgeLabel rect {
  opacity: 1 !important
}

.md-require-zoom-fix foreignObject {
  font-size: var(--mermaid-font-zoom)
}

@include-when-export url(https://fonts.loli.net/css?family=Didact+Gothic&display=swap&subset=cyrillic,cyrillic-ext,greek,greek-ext,latin-ext);

:root {
  --window-border: 0;
  --typora-center-window-title: true;
  --active-file-bg-color: #f3f3f3;
  --bg-color: #fcfcfc;
  --control-text-color: #777
}

.mac-seamless-mode #typora-sidebar {
  top: 20px;
  padding-top: 0;
  height: auto
}

html,
body,
#write {
  background: #fcfcfc;
  background: var(--bg-color);
  font-family: "lucida grande", "lucida sans unicode", lucida, helvetica, "Hiragino Sans GB", "Microsoft YaHei", "WenQuanYi Micro Hei", sans-serif;
  font-weight: 300
}

h1,
h2,
h3,
h4,
h5,
h6 {
  color: #111;
  font-family: "lucida grande", "lucida sans unicode", lucida, helvetica, "Hiragino Sans GB", "Microsoft YaHei", "WenQuanYi Micro Hei", sans-serif
}

html {
  font-size: 16px
}

#write {
  max-width: 700px;
  text-align: justify
}

@media only screen and (min-width:1400px) {
  #write {
    max-width: 1024px
  }
}

#write>h1:first-child {
  margin-top: 2.75rem
}

#write>h2:first-child {
  margin-top: 1.75rem
}

#write>h3:first-child {
  margin-top: 1rem
}

#write>h4:first-child {
  margin-top: .5rem
}

h1 {
  font-weight: normal;
  line-height: 4rem;
  margin: 0 0 1.75rem;
  padding: 20px 30px;
  text-align: center;
  text-transform: uppercase;
  margin-top: 4rem
}

h2 {
  font-weight: normal;
  line-height: 3rem;
  margin: 0 0 1.9375rem;
  padding: 0 30px;
  text-align: center;
  text-transform: uppercase;
  margin-top: 3rem
}

h3 {
  font-weight: normal
}

h4 {
  font-weight: normal
}

h5 {
  font-size: 1.125rem;
  font-weight: normal
}

h6 {
  font-size: 1rem;
  font-weight: bold
}

p {
  color: #111;
  font-size: 1rem;
  line-height: 1.75rem;
  margin: 0 0 1.25rem
}

#write>h3.md-focus:before {
  left: -1.875rem;
  top: .5rem;
  padding: 2px
}

#write>h4.md-focus:before {
  left: -1.875rem;
  top: .3125rem;
  padding: 2px
}

#write>h5.md-focus:before {
  left: -1.875rem;
  top: .25rem;
  padding: 2px
}

#write>h6.md-focus:before {
  left: -1.875rem;
  top: .125rem;
  padding: 2px
}

@media screen and (max-width:48em) {
  blockquote {
    margin-left: 1rem;
    margin-right: 0;
    padding: .5em
  }

  .h1,
  h1 {
    font-size: 2.827rem
  }

  .h2,
  h2 {
    font-size: 1.999rem
  }

  .h3,
  h3 {
    font-size: 1.413rem
  }

  .h4,
  h4 {
    font-size: 1.250rem
  }

  .h5,
  h5 {
    font-size: 1.150rem
  }

  .h6,
  h6 {
    font-size: 1rem
  }
}

a,
.md-def-url {
  color: #900;
  text-decoration: none
}

a:hover {
  text-decoration: underline
}

table {
  margin-bottom: 20px
}

table th,
table td {
  padding: 8px;
  line-height: 1.25rem;
  vertical-align: top;
  border-top: 1px solid #ddd
}

table th {
  font-weight: bold
}

table thead th {
  vertical-align: bottom
}

table caption+thead tr:first-child th,
table caption+thead tr:first-child td,
table colgroup+thead tr:first-child th,
table colgroup+thead tr:first-child td,
table thead:first-child tr:first-child th,
table thead:first-child tr:first-child td {
  border-top: 0
}

table tbody+tbody {
  border-top: 2px solid #ddd
}

code,
.md-fences {
  padding: .5em;
  border: 1px solid #ccc;
  padding: .1em;
  font-size: .9em;
  margin-left: .2em;
  margin-right: .2em
}

.md-fences {
  margin: 0 0 20px;
  font-size: 1em;
  padding: .3em 1em;
  padding-top: .4em
}

.task-list {
  padding-left: 0
}

.task-list-item {
  padding-left: 2.125rem
}

input {
  border-style: ridge
}

.task-list-item input {
  top: 3px
}

.md-task-list-item input {
  margin-left: -1.5em
}

.task-list-item input:before {
  content: "";
  display: inline-block;
  width: 1rem;
  height: 1rem;
  vertical-align: middle;
  text-align: center;
  border: 1px solid gray;
  background-color: #fdfdfd;
  margin-left: 0;
  -webkit-appearance: none;
  margin-top: -1rem
}

.typora-node .task-list-item input:before {
  top: .3ex;
  position: absolute
}

.task-list-item input:checked:before,
.task-list-item input[checked]:before {
  content: '\25FC';
  font-size: .8125rem;
  line-height: .9375rem
}

@media screen and (-webkit-min-device-pixel-ratio:0) and (min-resolution:.001dpcm) {
  .task-list-item input:before {
    margin-top: -0.2rem
  }

  .task-list-item input:checked:before,
  .task-list-item input[checked]:before {
    margin-top: -0.2rem
  }
}

blockquote {
  margin: 0 0 1.11111rem;
  padding: .5rem 1.11111rem 0 1.05556rem;
  border-left: 1px solid gray
}

blockquote,
blockquote p {
  line-height: 1.6;
  color: #6f6f6f
}

#write pre.md-meta-block {
  min-height: 30px;
  background: #f8f8f8;
  padding: 1.5em;
  font-weight: 300;
  font-size: 1em;
  padding-bottom: 1.5em;
  padding-top: 3em;
  margin-top: -1.5em;
  color: #999;
  width: 100vw;
  max-width: calc(100%+60px);
  margin-left: -30px;
  border-left: 30px #f8f8f8 solid;
  border-right: 30px #f8f8f8 solid
}

.MathJax_Display {
  font-size: .9em;
  margin-top: .5em;
  margin-bottom: 0
}

p.mathjax-block,
.mathjax-block {
  padding-bottom: 0
}

.mathjax-block>.code-tooltip {
  bottom: 5px;
  box-shadow: none
}

.md-image>.md-meta {
  padding-left: .5em;
  padding-right: .5em
}

.md-image>img {
  margin-top: 2px
}

.md-image>.md-meta:first-of-type:before {
  padding-left: 4px
}

#typora-source {
  color: #555
}

#md-searchpanel {
  border-bottom: 1px solid #ccc
}

#md-searchpanel .btn {
  border: 1px solid #ccc
}

#md-notification:before {
  top: 14px
}

#md-notification {
  background: #eee
}

.megamenu-menu-panel .btn {
  border: 1px solid #ccc
}

#typora-sidebar {
  box-shadow: none
}

.file-list-item,
.show-folder-name .file-list-item {
  padding-top: 20px;
  padding-bottom: 20px;
  line-height: 20px
}

.file-list-item-summary {
  height: 40px;
  line-height: 20px
}

.ty-table-edit {
  background: #ededed
}

.dropdown-menu .divider {
  border-color: #e5e5e5
}

:root {
  --mermaid-font-zoom: 1em
}
</style>